'use client';

import dynamic from 'next/dynamic';
import type { PropsWithChildren } from 'react';

// NOTE:
// `nuqs` (and/or its deps) can touch `localStorage` at module-eval time.
// When using `next build --turbopack`, we must ensure it is never imported
// during server prerendering.
const NuqsAdapter = dynamic(() => import('nuqs/adapters/next/app').then(m => m.NuqsAdapter), {
  ssr: false,
});

export const NuqsProvider = ({ children }: PropsWithChildren) => {
  return <NuqsAdapter>{children}</NuqsAdapter>;
};
